import { render, staticRenderFns } from "./ProfessorGeneroCard.vue?vue&type=template&id=0323d902"
import script from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
export * from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports